module.exports = __webpack_public_path__ + "img/morent.285357c9.png";